<template>
  <div class="contact">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
      <!-- 顶部大图 -->
      <section class="contact-banner">
        <img src="@/assets/images/lianjiejpg.jpg" alt="Contact Banner" class="banner-image">
      </section>

      <!-- 页面标题部分 -->
      <section class="page-header">
        <div class="container">
          <h1 class="page-title">{{ $t('contact.pageTitle') }}</h1>
        </div>
      </section>

      <!-- 联系信息 -->
      <section class="contact-section">
        <div class="container">
          <div class="contact-wrapper">
            <!-- 中文联系信息 -->
            <div class="contact-info">
              <h2 class="contact-info-title">北京之于行知识产权代理有限公司</h2>
              <div class="info-item">
                <div class="info-icon">
                  <i class="el-icon-location"></i>
                </div>
                <div class="info-text">
                  <p>北京市海淀区中关村南大街乙12号，</p>
                  <p>天作国际B座1201，</p>
                  <p>邮编：100081</p>
                </div>
              </div>
              <div class="info-item">
                <div class="info-icon">
                  <i class="el-icon-phone"></i>
                </div>
                <div class="info-text">
                  <p>电话：010 5094 0463</p>
                </div>
              </div>
              <div class="info-item">
                <div class="info-icon">
                  <i class="el-icon-message"></i>
                </div>
                <div class="info-text">
                  <p>邮箱：info@ipzhixin.cn</p>
                </div>
              </div>
              <div class="info-item">
                <div class="info-icon">
                  <i class="el-icon-link"></i>
                </div>
                <div class="info-text">
                  <p>网址：<a href="https://www.ipzhixin.com" target="_blank">https://www.ipzhixin.com</a></p>
                </div>
              </div>
            </div>
            
            <!-- 英文联系信息 -->
            <div class="contact-info">
              <h2 class="contact-info-title">Zhixin & Partners Law Firm Limited</h2>
              <div class="info-item">
                <div class="info-icon">
                  <i class="el-icon-location"></i>
                </div>
                <div class="info-text">
                  <p>Tianzuo International Center, Tower B-1201,</p>
                  <p>Zhongguancun South Avenue No.12,</p>
                  <p>Haidian District, Beijing,</p>
                  <p>100081 PR China</p>
                </div>
              </div>
              <div class="info-item">
                <div class="info-icon">
                  <i class="el-icon-phone"></i>
                </div>
                <div class="info-text">
                  <p>Phone: +86 10 5094 0463</p>
                </div>
              </div>
              <div class="info-item">
                <div class="info-icon">
                  <i class="el-icon-message"></i>
                </div>
                <div class="info-text">
                  <p>Email: info@ipzhixin.cn</p>
                </div>
              </div>
              <div class="info-item">
                <div class="info-icon">
                  <i class="el-icon-link"></i>
                </div>
                <div class="info-text">
                  <p>Website: <a href="https://www.ipzhixin.com" target="_blank">https://www.ipzhixin.com</a></p>
                </div>
              </div>
            </div>
            <!-- 新增发送邮件消息功能 -->
            <div class="contact-form">
              <h2 class="form-title">{{ $t('contact.sendMessage') }}</h2>
              <el-form :model="form" :rules="rules" ref="contactForm" label-width="0px" class="message-form">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="name">
                      <el-input v-model="form.name" :placeholder="$t('contact.name')" size="large" class="form-input"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="email">
                      <el-input v-model="form.email" :placeholder="$t('contact.email')" size="large" class="form-input"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="company">
                      <el-input v-model="form.company" :placeholder="$t('contact.company')" size="large" class="form-input"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="phone">
                      <el-input v-model="form.phone" :placeholder="$t('contact.phone')" size="large" class="form-input">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="country">
                      <el-input v-model="form.country" :placeholder="$t('contact.country')" size="large" class="form-input"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="subject">
                      <el-input v-model="form.subject" :placeholder="$t('contact.subject')" size="large" class="form-input"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item prop="message">
                  <el-input   v-model="form.message" :placeholder="$t('contact.message')" :rows="8" size="large" class="form-input"></el-input>
                </el-form-item>
                <el-form-item class="submit-item">
                  <el-button type="primary" size="large" @click="submitForm" class="submit-btn" :loading="isSubmitting">
                    {{ $t('contact.submit') }}
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import axios from 'axios'

export default {
  name: 'Contact',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        company: '',
        phone: '',
        country: '',
        subject: '',
        message: ''
      },
      lastSubmitTime: 0,
      isSubmitting: false,
      rules: {
        name: [
          { required: true, message: this.$t('contact.nameRequired'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('contact.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('contact.emailInvalid'), trigger: 'blur' }
        ],
        subject: [
          { required: true, message: this.$t('contact.subjectRequired'), trigger: 'blur' }
        ],
        message: [
          { required: true, message: this.$t('contact.messageRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm() {
      const now = Date.now()
      if (now - this.lastSubmitTime < 60000) {
        this.$message.warning('提交过于频繁，请稍后再试')
        return
      }

      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          this.lastSubmitTime = now
          this.isSubmitting = true
          
          axios.post('https://api.ipzhixin.com/site/mail/send', {
            contactName: this.form.name,
            email: this.form.email,
            to:"info@ipzhixin.cn",
            companyName: this.form.company,
            phone: this.form.phone,
            content: this.form.country,
            subject: this.form.subject,
            remark: this.form.message
          })
          .then(() => {
            this.$message.success(this.$t('contact.sendSuccess'))
            this.$refs.contactForm.resetFields()
          })
          .catch((error) => {
            this.$message.error(this.$t('contact.sendError'))
            console.error('邮件发送失败:', error)
          })
          .finally(() => {
            this.isSubmitting = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.contact {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 80vh;
}

/* 顶部大图 */
.contact-banner {
  width: 100%;
  height: 33.6rem;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 页面标题部分 */
.page-header {
  background-color: #FFF5F0;
  padding: 0rem 0;
  border-bottom: 1px solid #e9ecef;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
  text-align: center;
  color: #FF631E;
}

/* 通用样式 */
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 4rem 0;
}

.section-title {
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 2rem;
  color: #333;
}

/* 联系信息部分 */
.contact-section {
  padding: 0rem 0;
  background-color: #FFF5F0;
}

.contact-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 4rem;
  justify-content: space-between;
}

.contact-info {
  flex: 1;
  min-width: 300px;
  max-width: 500px;
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.contact-info-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #FF631E;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #FF631E;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 1.8rem;
}

.info-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background-color: #FFF5F0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-icon i {
  font-size: 1.3rem;
  color: #FF631E;
}

.info-text {
  font-size: 1rem;
  line-height: 1.8;
  color: #333;
}

.info-text p {
  margin: 0 0 0.5rem;
}

.info-text a {
  color: #FF631E;
  text-decoration: none;
  transition: color 0.3s ease;
}

.info-text a:hover {
  color: #d14b0f;
  text-decoration: underline;
}

/* 社交媒体样式 */
.social-media {
  margin-top: 3rem;
}

.social-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #f8f9fa;
  border-radius: 50%;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-link:hover {
  background-color: #007bff;
  color: white;
}

.social-link i {
  font-size: 1.2rem;
}

/* 联系表单样式 */
.contact-form {
  flex: 2;
  min-width: 500px;
  background-color: #fff;
  padding: 2.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.form-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #FF631E;
}

.message-form {
  width: 100%;
}

.form-input {
  width: 100%;
  margin-bottom: 0.5rem;
}

.form-input ::v-deep .el-input__inner {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  height: 50px;
  font-size: 1rem;
  padding: 0 1rem;
  transition: all 0.3s ease;
}

.form-input ::v-deep .el-input__inner:focus {
  border-color: #FF631E;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(255, 99, 30, 0.1);
}

.form-input ::v-deep .el-input-group__prepend {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-right: none;
  border-radius: 8px 0 0 8px;
  padding: 0 1rem;
  font-size: 1rem;
  color: #6c757d;
}

.form-input ::v-deep .el-input__prefix {
  left: 1rem;
}

.form-input ::v-deep .el-select__caret {
  color: #6c757d;
}

.form-textarea {
  width: 100%;
}

.form-textarea ::v-deep .el-textarea__inner {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-size: 1rem;
  padding: 1rem;
  transition: all 0.3s ease;
  resize: vertical;
  min-height: 150px;
}

.form-textarea ::v-deep .el-textarea__inner:focus {
  border-color: #FF631E;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(255, 99, 30, 0.1);
}

.submit-item {
  text-align: right;
  margin-top: 1rem;
}

.submit-btn {
  background-color: #FF631E;
  border-color: #FF631E;
  border-radius: 8px;
  padding: 0 3rem;
  height: 50px;
  font-size: 1.1rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background-color: #e85a1b;
  border-color: #e85a1b;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 99, 30, 0.3);
}

.submit-btn:active {
  transform: translateY(0);
}

@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
  
  .contact-banner {
    height: 600px;
  }
  
  .contact-wrapper {
    flex-direction: column;
    gap: 2rem;
  }
  
  .contact-info,
  .contact-form {
    max-width: 100%;
    min-width: auto;
  }
}

@media (max-width: 768px) {
  .contact-form {
    padding: 1.5rem;
  }
  
  .el-col {
    width: 100% !important;
  }
  
  .submit-item {
    text-align: center;
  }
  
  .submit-btn {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .contact-wrapper {
    gap: 2rem;
  }
  
  .contact-info {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .contact-wrapper {
    flex-direction: column;
    align-items: center;
  }
  
  .contact-info {
    width: 100%;
  }
  
  .page-title {
    font-size: 2rem;
  }
  
  .contact-info-title {
    font-size: 1.3rem;
  }
  
  .contact-banner {
    height: 400px;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 1.8rem;
  }
  
  .contact-info {
    padding: 1.5rem;
  }
  
  .info-item {
    gap: 1rem;
  }
  
  .info-icon {
    width: 35px;
    height: 35px;
  }
  
  .info-text {
    font-size: 0.9rem;
  }
  
  .contact-banner {
    height: 300px;
  }
}
</style>